import { type ChatModel } from '@/shared/api'
import { HubConnectionState } from '@microsoft/signalr'
import {
  attach,
  createEffect,
  createEvent,
  createStore,
  restore,
  sample,
} from 'effector'
import { createGate } from 'effector-react'

import { feedbacksSignalRService } from '../api/signalr'

export const FeedbackSignalRGate = createGate()

/**
 * Feature: Подключение к SignalR и получение новых сообщений
 */
const $signalRInstance = createStore(feedbacksSignalRService)

export const newMessageReceived = createEvent<ChatModel>()

const connectSignalRFx = attach({
  source: $signalRInstance,
  async effect(instance) {
    await instance.connect()
    instance.offNewMessage()
    instance.onNewMessage(newMessageReceived)
  },
})

const disconnectSignalRFx = attach({
  source: $signalRInstance,
  async effect(instance) {
    instance.offNewMessage()
    await instance.disconnect()
  },
})

sample({
  clock: FeedbackSignalRGate.open,
  target: connectSignalRFx,
})

sample({
  clock: FeedbackSignalRGate.close,
  target: disconnectSignalRFx,
})

/**
 * Feature: Контроль состояния соединения SignalR
 */
const pollConnectionState = createEvent()
const pollConnectionStateFx = attach({
  source: $signalRInstance,
  effect(instance) {
    return instance.connectionState
  },
})

export const $connectionState = restore(
  pollConnectionStateFx.doneData,
  HubConnectionState.Disconnected,
)

sample({
  clock: pollConnectionState,
  target: pollConnectionStateFx,
})

// Периодический опрос состояния
let statePollingInterval: NodeJS.Timeout | null = null
const CONNECTION_POLLING_INTERVAL_MS = 500

const startStatePollingFx = createEffect(() => {
  if (statePollingInterval) return
  statePollingInterval = setInterval(() => {
    pollConnectionState()
  }, CONNECTION_POLLING_INTERVAL_MS)
})

const stopStatePollingFx = createEffect(() => {
  if (statePollingInterval) {
    clearInterval(statePollingInterval)
    statePollingInterval = null
  }
})

// Запуск опроса при подключении
sample({
  clock: connectSignalRFx.doneData,
  target: [pollConnectionState, startStatePollingFx],
})

// Остановка опроса при отключении
sample({
  clock: disconnectSignalRFx.doneData,
  target: [pollConnectionState, stopStatePollingFx],
})
